function LoginModule() {
  return <div className='w-[500px] border border-red-200'>Login</div>;
}

export default LoginModule;
